const CHANNEL_NAME = "premium_tab_sync";

let channel = null;

const getChannel = () => {
  if (!channel && typeof BroadcastChannel !== "undefined") {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
};

export function broadcastLogout() {
  const ch = getChannel();
  if (ch) {
    try {
      ch.postMessage({ type: "force-logout" });
    } catch (err) {
      // ignore
    }
  }
}

export function listenForForceLogout(callback) {
  const ch = getChannel();
  if (!ch) return () => {};

  const handler = (event) => {
    const data = event.data || {};
    if (data.type === "force-logout") {
      callback();
    }
  };

  ch.addEventListener("message", handler);
  return () => ch.removeEventListener("message", handler);
}
